import React from "react";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import ConfigurationHeader from "./header";
import CustomInput from "../../../components/TextField/TextFeild";
import { updateUserProfile } from "../../../store/slices/authSlice";
import AdsUnpaid from "../Admax/AdsUnpaid";
import Swal from "sweetalert2";

// Formik validation schema
const validationSchema = Yup.object({
    title: Yup.string().required("Title is required"),
    url: Yup.string()
        .required("RSS URL is required")
        .url("Invalid URL format"),
});

const Podcast = () => {
    const { user } = useSelector((state) => state.auth);
    const { attributes: { enablePodcast } } = user;
    const dispatch = useDispatch();

    const formik = useFormik({
        initialValues: {
            title: user?.attributes.podcast?.title,
            url: user?.attributes.podcast?.url,
        },
        validationSchema: validationSchema,
        onSubmit: async (inputs) => {
            if (!enablePodcast) {
                showAlert()
            } else {
                const isForStation = user?.attributes?.isOwner == false ? true : false;
                dispatch(updateUserProfile({ message: "Record Updated Successfully.", values: { podcast: { ...inputs } }, isForStation }));
            }
        },
    });


    const showAlert = () => {
        Swal.fire("Not-Allowed", "Podcast is a premium feature that can be used in your application.<br> Please contact us for pricing: support@radiofxinc.com.");
    }

    return (
        <div className="section_main_div">
            <h1 className="section_heading">Configure</h1>
            <ConfigurationHeader />
            {!enablePodcast && <AdsUnpaid title={'Podcast '} />}

            <form className={`form_div ${!enablePodcast ? 'mt-4' : ''}`} onSubmit={formik.handleSubmit}>
                <div className="form-card">
                    <div className="form-elements">
                        <CustomInput
                            label="Title"
                            id="title"
                            name="title"
                            value={formik.values.title}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.title && formik.errors.title}
                            required
                        />
                        <CustomInput
                            label="RSS Feed /URL, in format https://"
                            id="url"
                            name="url"
                            value={formik.values.url}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.url && formik.errors.url}
                            required
                        />
                    </div>
                </div>

                <div className="text-right">
                    <div className="button-div">
                        <button type="submit" disabled={formik.isSubmitting}>
                            <span>{formik.isSubmitting ? "Saving..." : "Update"}</span>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default Podcast;
